import PropTypes, { oneOfType } from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import Menu from './Menu';
import MenuItem from './MenuItem';
import ArrowIcon from '../../../img/sprite/arrow-right.svg';
import {
  PATH_REDEEM_CODE, ENABLE_ORG_MANAGEMENT, ORG_PATHS,
} from '../constants';
import { Switch, Route } from 'react-router';
import OrgNavMenu from '../containers/org/OrgNavMenu';
import PersonNavMenu from './PersonNavMenu';

const SharedIconStyles = css`
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  li  li & {
    display: none;
  }
`;

const ActiveIcon = styled.svg`
  ${SharedIconStyles}
  margin-left: 0.692em;
  margin-top: -0.308em;
  transform: rotate(90deg);
`;

const InactiveIcon = styled.svg`
  ${SharedIconStyles}
  margin-left: 0.462em;
  margin-top: -0.231em;
`;

const NavMenu = (props) => {
    const { location, isOpen, navToggle, isLoggedIn, isMobile, isBreadCrumb, renderBreadCrumb } = props;

    const styles = styles || {};
    const icons = props.icons || {
      activeIcon: <ActiveIcon><use xlinkHref={`#${ArrowIcon.id}`} /></ActiveIcon>,
      inactiveIcon: <InactiveIcon><use xlinkHref={`#${ArrowIcon.id}`} /></InactiveIcon>
    };
    const NavItem = (props) => <MenuItem location={location} icons={icons} styles={styles} navToggle={navToggle} isOpen={isOpen} {...props} />;
    const NavList = (props) => <Menu styles={styles} {...props} />;

    const menuProps = { location, navToggle, isOpen, isMobile, isBreadCrumb, renderBreadCrumb };

    const MenuLoggedIn = (
      <Switch>
        {ENABLE_ORG_MANAGEMENT && <Route path={ORG_PATHS.BASE} render={() => <OrgNavMenu {...menuProps} />} />}
        <Route render={() => <PersonNavMenu {...menuProps} />} />
      </Switch>
    );

    const MenuLoggedOut = (
      <NavList isActive>
        <NavItem onlyChild title="Redeem Code" href={PATH_REDEEM_CODE} data-qa-hook="redeemCode.link" />
      </NavList>
    );
    //need to revisit for a better solution //
    const menu = (isLoggedIn === undefined || isLoggedIn) ? MenuLoggedIn : MenuLoggedOut;

    return (props.noRender) ? null : menu;
};

const { object, func, bool, shape, node, string, array } = PropTypes;

NavMenu.propTypes = {
  location: object.isRequired,
  navToggle: func,
  noRender: bool,
  isOpen: bool,
  isLoggedIn: bool,
  isMobile: bool,
  isBreadCrumb: bool,
  renderBreadCrumb: func,
  icons: shape({
    iconActive: node,
    iconInactive: node
  }),
  // Will warn sometimes until all are changed to Styled-Components: string VS array //
  styles: shape({
    ulCommon: oneOfType([array, string]),
    ulActive: oneOfType([array, string]),
    ulInactive: oneOfType([array, string]),
    liCommon: oneOfType([array, string]),
    liActive: oneOfType([array, string]),
    liInactive: oneOfType([array, string]),
    aCommon: oneOfType([array, string]),
    aActive: oneOfType([array, string]),
    aInactive: oneOfType([array, string]),
    firstChildStyles: object,
    lastChildStyles: object,
  })
};

export default NavMenu;
